'use client';

import { EmptyState } from '@yanolja-rnd/nol-design-system';
import { useImpressionLog } from '@/app/_shared/hooks/use-impression-log';

interface NoKeywordSearchResultProps {
  title?: string;
  description?: string;
  onImpression?: () => void;
}

export const NoKeywordSearchResult = ({ title, description, onImpression }: NoKeywordSearchResultProps) => {
  const ref = useImpressionLog(onImpression);

  return (
    <div ref={ref} className="flex h-full w-full justify-center bg-colors-white">
      <EmptyState
        title={title || '일치하는 검색 결과가 없어요'}
        description={description || '지역명, 상품명으로 검색어를 변경해 보세요.'}
        pcType="pcLegacySize"
      />
    </div>
  );
};
